import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { ref } from 'vue';

const DEFAULT_TITLE_COPY = "to get scholarship updates";

export default class RegistrationHeader {
	public titleCopy = ref<string>(DEFAULT_TITLE_COPY);
	public subText = ref<string>(
		'Receive personalised scholarship recommendations and reminders before application deadlines',
	);
	constructor(private store: IIncentiveV2Store) {}
}